<template>
  <div id="appointment" class="container">
    <div class="appointment-wrap style7">
      <div class="row gx-5 align-items-center">
        <div class="col-lg-6">
          <div class="appointment-bg-three bg-f"></div>
        </div>

        <div class="col-lg-6">
          <div class="book-appointment style2">
            <h5>Book An Online Appointment</h5>
            <form action="#">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" placeholder="Full Name" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" placeholder="Email Address" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="number" placeholder="Phone Number" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Booking Date"
                      onfocus="(this.type='date')"
                      onblur="(this.type='text')"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <select name="dept" id="dept">
                      <option data-display="Select Department" value="0">
                        Department
                      </option>
                      <option value="1">Dental Health</option>
                      <option value="2">Physical Health</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <select name="doc" id="doc">
                      <option data-display="Select Doctor" value="0">
                        Select Doctor
                      </option>
                      <option value="1">Dr. Josef Henry</option>
                      <option value="2">Dr. Kevin Martin</option>
                    </select>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-group">
                    <select name="location" id="location">
                      <option data-display="Select Location" value="0">
                        Select Location
                      </option>
                      <option value="1">South Arizona</option>
                      <option value="2">Florida</option>
                    </select>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-group">
                    <textarea
                      name="messgae"
                      id="message"
                      cols="30"
                      rows="10"
                      placeholder="Message"
                    ></textarea>
                  </div>
                </div>

                <div class="col-12">
                  <button type="submit" class="btn style2">
                    Book An Appointment
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookAnAppointment ",
};
</script>